<template>
  <tr class="body-row">
    <td
      class="row-column"
      colspan="999"
    >
      <span
        class="column-skeleton"
        :style="computedStyle"
      ></span>
    </td>
  </tr>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  /**
   * Set the width of the Skeleton loader bar to a fixed value, use % or px, e.g. '90%' or '200px'.
   */
  width?: string
  /**
   * Skeleton loader bar minimum width in percent.
   */
  minWidth?: string
  /**
   * Skeleton loader bar max width in percent.
   */
  maxWidth?: string
  /**
   * Skeleton loader bar height in px, default 38
   */
  height?: number
}

const props = withDefaults(defineProps<Props>(), {
  width: undefined,
  minWidth: '80',
  maxWidth: '100',
  height: 38
})

const computedStyle = computed(() => {
  /*
   * Either use the given fixed width or a random width
   * between the given min and max values.
   */
  const width = props.width ?? (Math.floor(
    Math.random() * (parseInt(props.maxWidth) - parseInt(props.minWidth)) +
    parseInt(props.minWidth))) + '%'

  // bootstrap 4 gives td elements in a table-sm a padding of 0.3rem on top and bottom, correct this
  const correctedHeight = props.height - (2 * 0.3 * 16)

  return {
    width: width,
    height: correctedHeight + 'px'
  }
})
</script>

<style lang="scss">
.column-skeleton {
  display: inline-block;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  background-color: #dddbdd;

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg,
        rgba(#fff, 0) 0,
        rgba(#fff, 0.2) 20%,
        rgba(#fff, 0.5) 60%,
        rgba(#fff, 0));
    animation: shimmer 2s infinite;
    content: '';
  }

  @keyframes shimmer {
    100% {
      transform: translateX(100%);
    }
  }
}
</style>
